import { FormControlLabel, FormHelperText, Stack, Switch } from '@mui/material';
import { useState } from 'react';

import { isTruthy } from 'common';

import { BlockValueTemplateFieldArea } from '../../../ConfigFields/CodeMirror/FlowTemplate.tsx';

interface VisionLanguageModelFieldsProps {
  isEditable: boolean;
  prompt: string | undefined;
}

export function VisionLanguageModelFields(props: VisionLanguageModelFieldsProps) {
  const { isEditable, prompt } = props;

  const [isCustomPromptEnabled, setIsCustomPromptEnabled] = useState(() => isTruthy(prompt));

  return (
    <Stack spacing={2}>
      <div>
        <FormControlLabel
          control={
            <Switch
              checked={isCustomPromptEnabled}
              onChange={(_event, checked) => {
                setIsCustomPromptEnabled(checked);
              }}
              disabled={!isEditable}
            />
          }
          label="Custom prompt"
        />
        <FormHelperText>
          Custom instructions will be added to the OCR instructions. Use this to include specialized
          requirements for your document type, additional context, or additional output formatting
          instructions for your use case.
        </FormHelperText>
      </div>
      {isCustomPromptEnabled && (
        <BlockValueTemplateFieldArea
          label="Prompt"
          fieldName="config.prompt"
          helperText="Customize instructions sent to the vision model."
        />
      )}
    </Stack>
  );
}
